import styled from 'styled-components'

export const BoxTitle = styled.div`
  margin-bottom: 4px;
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

export const ListTransfer = {
  width: '100%',
  height: 300,
  bgcolor: 'background.paper',
  border: '1px solid hsl(214, 32%, 91%)',
  borderRadius: '5px',
}

export const GridBoxItemStyle = {
  width: '93%',
  padding: '10px',
  borderColor: '#9a9a9b',
}

export const CardSubtitle = styled.span`
  font-size: 10px;
`

export const TitleGridItems = styled.div`
  margin-bottom: 0px;
  font-size: 14px;
`
